module.exports = __webpack_public_path__ + "static/media/1A.fec52daa.png";